import { useEffect } from 'react';
import { filterWidgetEvent } from '@client/foundation/shared/utils/filter-widget-event';
import { WidgetPayload } from '@client/widgets/widget.types';
import { useApiManagementState } from './api-management.hook';
import { useWidget } from '@client/widgets/widget.hook';
import { useWindow } from '@client/window/window.hook';

export const useAddExchangeFormEvents = () => {
  const { openWidget$ } = useWidget();
  const { openWindow, closeWindow } = useWindow();
  const { addExchange } = useApiManagementState();

  useEffect(() => {
    const subscription = openWidget$()
      .pipe(
        filterWidgetEvent<WidgetPayload, 'AddExchangeForm'>('AddExchangeForm')
      )
      .subscribe(({ type }) => {
        openWindow({
          type: 'AddExchangeForm',
          componentProps: {
            onSubmit: ({ exchangeId }) => {
              addExchange({
                exchangeId,
                apiKeys: {}
              });
              closeWindow(type);
            }
          }
        });
      });

    return () => {
      subscription.unsubscribe();
    };
  }, [openWindow, closeWindow]);
};
